import React from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

const PrivacyPolicy = () => {
  const today = new Date().toLocaleDateString();

  return (
    <>
      <div style={{ paddingBottom: "80px", paddingTop: "10px" }}>
        <Navbar />
      </div>
      <div className="containe mt-2 pt-5 mb-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <h1 className="text-center mb-4">Privacy Policy</h1>
            <p className="text-center text-muted mb-5">
              Effective Date: {today}
            </p>

            <p>
              <strong>Company Name:</strong> HR Pundits
              <br />
              <strong>Website:</strong>{" "}
              <a
                href="https://hrpundits.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://hrpundits.com
              </a>
            </p>

            <p>
              At HR Pundits, we value your privacy and are committed to
              protecting your personal information. This Privacy Policy outlines
              how we collect, use, and safeguard the data you share with us.
            </p>

            <h5 className="mt-4">1. Information We Collect</h5>
            <p>We may collect the following information when you:</p>
            <ul>
              <li>Visit our website</li>
              <li>Register for training</li>
              <li>Interact with our ads</li>
            </ul>
            <p>This information may include:</p>
            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Location</li>
              <li>Job title or area of interest</li>
              <li>
                Any other information you voluntarily submit through forms or
                contact
              </li>
            </ul>

            <h5 className="mt-4">2. How We Use Your Information</h5>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide details about our training programs</li>
              <li>Respond to your inquiries</li>
              <li>Send important updates or promotional content</li>
              <li>Improve our website and services</li>
              <li>Conduct internal analytics and performance tracking</li>
              <li>Comply with legal requirements</li>
            </ul>

            <h5 className="mt-4">3. Sharing of Information</h5>
            <p>
              We do <strong>not</strong> sell or rent your personal information.
              We may share your data with trusted third parties only when:
            </p>
            <ul>
              <li>
                It is required to deliver our services (e.g., email marketing
                platforms)
              </li>
              <li>We are legally required to do so</li>
              <li>
                It is necessary to protect the rights, property, or safety of HR
                Pundits or others
              </li>
            </ul>

            <h5 className="mt-4">4. Data Security</h5>
            <p>
              We take reasonable steps to ensure your data is secure and
              protected against unauthorized access, alteration, or disclosure.
            </p>

            <h5 className="mt-4">5. Your Choices</h5>
            <p>
              You may opt out of receiving promotional emails by using the
              unsubscribe link in any email. You can also contact us to update,
              correct, or delete your personal information.
            </p>

            <h5 className="mt-4">6. Third-Party Links</h5>
            <p>
              Our website may contain links to third-party websites. We are not
              responsible for the privacy practices of those sites.
            </p>

            <h5 className="mt-4">7. Updates to This Policy</h5>
            <p>
              We may update this Privacy Policy from time to time. Changes will
              be posted on this page with the revised effective date.
            </p>

            <h5 className="mt-4">8. Contact Us</h5>
            <p>
              If you have any questions or concerns about this policy, please
              contact us at:
              <br />
              <strong>HR Pundits</strong>
              <br />
              Email:{" "}
              <a href="mailto:support@hrpundits.com">support@hrpundits.com</a>
              <br />
              Website:{" "}
              <a
                href="https://hrpundits.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://hrpundits.com
              </a>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
